import React, { Component } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import $ from 'jquery'
import ReactTooltip from 'react-tooltip'
import { Info } from '@phosphor-icons/react'
import { withTranslation, useTranslation } from 'react-i18next'

import Icon from '../Icons'
import {
  getTrainingType,
  formatStartAndEndDates,
  getTimezoneShortName,
  getBuildingTimezoneFromEvent,
} from '../../helpers/helpers'
import { getAssetLink } from '../../helpers/get-asset-link'
import ConfirmPopup from '../Popups/ConfirmPopup'
import API from '../../api/api'
import withHookSnackbar from '../../helpers/hooks/hocUseSnackbar'

import SelectEventRefundOption from './SelectEventRefundOption'
import EditEventSchedule from './EditEventSchedule'

const ALLOWED_USER_ROLES = ['PropertyManager', 'Manager', 'ShiftManager']
const ADMIN_OR_PM = ['Administrator', 'Manager', 'PropertyManager']

const EditButton = ({ pathname, event }) => {
  const navigate = useNavigate()
  const { t } = useTranslation(['common'])

  return (
    <button
      className="button button-primary auto-width"
      onClick={() => {
        navigate(`${pathname}/${event.id}`)
      }}
    >
      {t('common:actions.edit')}
    </button>
  )
}

const getEventFormType = (event) => {
  if (Object.keys(event).length === 0) {
    return ''
  }

  const isBuildingEvent = event.event
  const isReminder = event.type.name === 'Reminder'
  const isAppointment = event.mainClient
  let eventType = ''

  if (isBuildingEvent) {
    eventType = 'event'
  } else if (isReminder) {
    eventType = 'reminder'
  } else if (isAppointment) {
    eventType = 'appointment'
  } else {
    eventType = 'class'
  }

  return eventType
}

class CalendarEventPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      arrowPosition: '',
      confirmPopupOpen: false,
      selectEventsToChangePopupOpen: false,
      mode: '',
      eventsToUpdate: 'false',
      refundPopupOpen: false,
      refund: false,
    }
    this.handleCancelEvent = this.handleCancelEvent.bind(this)
    this.handleDeleteEvent = this.handleDeleteEvent.bind(this)
    this.handleClosePopup = this.handleClosePopup.bind(this)
    this.handleOpenSelectEventsPopup = this.handleOpenSelectEventsPopup.bind(this)
    this.handleAction = this.handleAction.bind(this)
    this.handleEventsToUpdateChange = this.handleEventsToUpdateChange.bind(this)
    this.handleSetRefund = this.handleSetRefund.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const { open, target } = nextProps

    if (target?.length === 0) return

    if (open) {
      this.calculatePopupPosition(target)
      this.removeEventActiveClass()
      this.setEventActiveClass(target)
    } else {
      this.removeEventActiveClass()
    }
  }

  calculatePopupPosition(target) {
    const popup = $('.ctp-event-popup')
    const arrow = $('.ctp-event-popup__arrow')
    const container = $('.ctp-calendar')

    const popupHeight = popup.outerHeight()
    const popupWidth = popup.outerWidth()
    const containerOffset = container.offset()
    const containerWidth = container.width()
    const scrollTop = container.scrollTop()
    const scrollLeft = container.scrollLeft()

    const targetOffset = target.offset()
    const targetHeight = target.outerHeight()
    const targetWidth = target.outerWidth()

    const targetTopInContent = targetOffset.top - containerOffset.top + scrollTop
    const targetLeftInContent = targetOffset.left - containerOffset.left + scrollLeft
    const targetCenterYInContent = targetTopInContent + targetHeight / 2

    const targetRightInContent = targetLeftInContent + targetWidth
    const spaceOnRight = containerWidth - (targetRightInContent - scrollLeft)

    let popupLeft
    if (spaceOnRight >= popupWidth) {
      popupLeft = targetRightInContent
      this.setState({ arrowPosition: 'left' })
    } else {
      popupLeft = targetLeftInContent - popupWidth
      this.setState({ arrowPosition: 'right' })
    }

    let popupTop = targetCenterYInContent - popupHeight / 2

    const minTop = scrollTop
    const maxTop = scrollTop + container.height() - popupHeight
    popupTop = Math.max(minTop, Math.min(maxTop, popupTop))

    popup.css({ left: popupLeft, top: popupTop })

    const arrowTop = targetCenterYInContent - popupTop - 8
    arrow.css({ top: arrowTop, bottom: 'auto' })
  }

  setEventActiveClass(target) {
    target.addClass('ctp-event--active')
  }

  removeEventActiveClass() {
    $('.ctp-event').removeClass('ctp-event--active')
  }

  renderLocation(e) {
    if (typeof e.buildingId !== 'undefined' && e.buildingId !== null) {
      return (
        <div className="ctp-event-popup__detail">
          <span className="ctp-event-popup__detail-title">
            {this.props.t('calendar:eventPopup.location')}{' '}
          </span>
          <div className="ctp-event-popup__detail-info">
            <div className="ctp-event-popup__icon ctp-event-popup__icon--small">
              <Icon icon="building" />
            </div>
            <span> {e.buildingId.name} </span>
          </div>
        </div>
      )
    } else {
      return ''
    }
  }

  renderTrainer(e) {
    if (typeof e.trainerId !== 'undefined' && e.trainerId !== null) {
      const trainerData = e.trainerId.user ? e.trainerId.user : e.trainerId
      return (
        <div className="ctp-event-popup__detail">
          <span className="ctp-event-popup__detail-title">
            {this.props.t('calendar:eventPopup.staff')}{' '}
          </span>
          <div className="ctp-event-popup__detail-info">
            <div className="ctp-event-popup__avatar">
              <img
                src={getAssetLink({ path: 'chitown-avatar/avatar', file: trainerData.avatar })}
              />
            </div>
            <span>
              {trainerData.firstName} {trainerData.lastName}
            </span>
          </div>
        </div>
      )
    } else {
      return ''
    }
  }

  handleOpenCancelDeletePopup(mode) {
    this.setState((prev) => ({
      ...prev,
      ...(mode && { mode }),
      confirmPopupOpen: true,
      selectEventsToChangePopupOpen: false,
    }))
  }

  handleOpenSelectEventsPopup(cancelOrDelete) {
    this.setState((prev) => ({
      ...prev,
      selectEventsToChangePopupOpen: true,
      mode: cancelOrDelete,
    }))
  }

  handleOpenRefundPopup(mode) {
    this.setState((prev) => ({
      ...prev,
      refundPopupOpen: true,
      mode,
    }))
  }

  hasPaidTickets() {
    const { tickets } = this.props.event
    return Array.isArray(tickets) && tickets.some((ticket) => ticket?.price > 0)
  }

  async handleCancelEvent() {
    const sendData = { canceled: true }

    if (this.hasPaidTickets()) {
      sendData.refund = this.state.refund
    }

    try {
      await API.updateEvent(this.props.event.id, sendData, this.state.eventsToUpdate)
      await this.props.refetchEvents()

      if (sendData.refund) {
        this.props.displaySnackbar(this.props.t('calendar:eventPopup.cancelWithRefundMessage'))
      } else {
        this.props.displaySnackbar(this.props.t('calendar:eventPopup.cancelledMessage'))
      }
    } catch (error) {
      const message = error.message || this.props.t('calendar:eventPopup.genericError')
      this.props.displaySnackbar(message, true)
    } finally {
      this.setState((prev) => ({ ...prev, confirmPopupOpen: false, mode: '', refund: false }))
    }
  }

  async handleDeleteEvent() {
    const shouldRefund = this.state.refund

    try {
      await API.deleteEvent(this.props.event.id, this.state.eventsToUpdate, shouldRefund)
      await this.props.refetchEvents()

      if (shouldRefund) {
        this.props.displaySnackbar(this.props.t('calendar:eventPopup.cancelWithRefundMessage'))
      } else {
        this.props.displaySnackbar(this.props.t('calendar:eventPopup.deletedMessage'))
      }
    } catch (error) {
      const message = error.message || this.props.t('calendar:eventPopup.genericError')
      this.props.displaySnackbar(message, true)
    } finally {
      this.setState((prev) => ({
        ...prev,
        confirmPopupOpen: false,
        mode: '',
        refund: false,
      }))
    }
  }

  handleClosePopup(name) {
    this.setState((prev) => ({ ...prev, [name]: false }))
  }

  handleEventsToUpdateChange(e) {
    this.setState((prev) => ({ ...prev, eventsToUpdate: e.target.value }))
  }

  handleSetRefund(refund) {
    this.setState((prev) => ({ ...prev, refund }))
  }

  handleAction() {
    if (this.state.mode === 'cancel') {
      this.handleCancelEvent()
    } else {
      this.handleDeleteEvent()
    }
    this.handleClosePopup('confirmPopupOpen')
  }

  handleShowPopup(mode) {
    const { repeatCorrelationId } = this.props.event
    if (this.hasPaidTickets()) {
      this.handleOpenRefundPopup(mode)
    } else if (repeatCorrelationId) {
      this.handleOpenSelectEventsPopup(mode)
    } else {
      this.handleOpenCancelDeletePopup(mode)
    }
  }

  canEditEvent(userRole, event, dateValid) {
    const specialEditors = ALLOWED_USER_ROLES.includes(userRole)
    const isRoleAllowed = ['Administrator', 'Manager', 'PropertyManager', 'ShiftManager'].includes(
      userRole,
    )
    const isClassEvent = getTrainingType(event) === 'class'
    const isAppointmentEvent = getTrainingType(event) === 'appointment'

    if (
      (isClassEvent || isAppointmentEvent) &&
      ['PropertyManager', 'ShiftManager'].includes(userRole)
    ) {
      return false
    }

    return (specialEditors && !isClassEvent) || (isAppointmentEvent && dateValid) || isRoleAllowed
  }

  render() {
    const {
      userRole,
      event,
      open,
      onClose,
      onEditEvent: _onEditEvent,
      openAttendingPopup,
      t,
    } = this.props
    const trainingType = getTrainingType(event)
    let eventIcon = ''
    let eventIconViewBox = ''
    let eventType = event.name
    let isAppointment = false
    let buildingName = ''
    if (typeof event.id !== 'undefined' && event.type) {
      eventIcon = event.type.icon
      eventType = event.type.name
      isAppointment = event.type.personal
      buildingName = event.buildingId ? event.buildingId.name : ''
    }
    const dateValid = moment(event.date).isAfter(moment(), 'hour')

    const timezone = getBuildingTimezoneFromEvent(this.props.event)

    let [start, end] = formatStartAndEndDates(trainingType, event, timezone)

    const eventFormType = getEventFormType(event)

    const shouldShowManageRSVPButton =
      !['reminder'].includes(trainingType) &&
      ['Trainer', 'Manager', 'Administrator', 'ShiftManager', 'PropertyManager'].includes(userRole)

    return (
      <div
        className={`ctp-event-popup ${open ? 'ctp-event-popup--active' : ''} ${
          this.state.arrowPosition === 'right' ? 'ctp-event-popup--pos-right' : ''
        }`}
      >
        <span className="ctp-event-popup__arrow" />
        <header className="ctp-event-popup__header">
          <div className="ctp-event-popup__header-inner">
            <div className="ctp-event-popup__icon">
              <Icon icon={eventIcon} viewBox={eventIconViewBox} />
            </div>
            <div className="ctp-event-popup__image">
              <img
                src={getAssetLink({
                  path: 'chitown-images/training',
                  file: event.image || 'training_image.png',
                  fallback: { file: 'training_image.png' },
                })}
                alt={event.title}
              />
            </div>
            <div className="ctp-event-popup__title">
              <h2>
                {isAppointment || userRole === 'Client' || userRole === 'PropertyManager'
                  ? event.title
                  : `${buildingName} - ${event.title}`}
              </h2>
            </div>
            <div className="ctp-event-popup__actions">
              {['PropertyManager', 'Manager', 'Administrator', 'ShiftManager'].includes(userRole) &&
                userRole !== 'public' && (
                  <button
                    className="button button-lightgray"
                    onClick={(e) => openAttendingPopup(e, 'notify', event)}
                  >
                    <span> {t('calendar:eventPopup.email')} </span>
                  </button>
                )}
              {shouldShowManageRSVPButton && (
                <Link
                  className="button button-lightgray"
                  to={`/dashboard/calendar/${event.id}/attendees`}
                >
                  {t('calendar:eventPopup.manageRsvp')}
                </Link>
              )}
            </div>
          </div>
          <div className="ctp-event-popup__close">
            <button
              onClick={(e) => {
                e.preventDefault()
                onClose()
              }}
            >
              <Icon icon="cross" />
            </button>
          </div>
        </header>
        <div className="ctp-event-popup__inner">
          {!event.endDate && timezone ? (
            <time className="ctp-event-popup__time">
              {start} - {end}
              {timezone ? ` ${getTimezoneShortName(timezone)}` : null}
            </time>
          ) : null}
          {this.renderLocation(event)}
          {ADMIN_OR_PM.includes(userRole) && this.renderTrainer(event)}
          <div className="ctp-event-popup__detail">
            <span className="ctp-event-popup__detail-title">
              {t('calendar:eventPopup.eventType')}{' '}
            </span>
            <div className="ctp-event-popup__detail-info">
              <span> {eventType} </span>
            </div>
          </div>
          <div className="ctp-event-popup__detail">
            <span className="ctp-event-popup__detail-title">
              {t('calendar:eventPopup.visibility')}{' '}
            </span>
            <div className="ctp-event-popup__detail-info">
              <span>
                {' '}
                {event.isPrivate
                  ? t('calendar:eventPopup.private')
                  : t('calendar:eventPopup.public')}{' '}
              </span>
            </div>
          </div>
          {!['appointment', 'reminder'].includes(getTrainingType(event)) && !event.signUpLink && (
            <React.Fragment>
              <div className="ctp-event-popup__detail">
                <span className="ctp-event-popup__detail-title">
                  {t('calendar:eventPopup.registered')}{' '}
                  <Info className="info" data-tip data-for="registered-tip" size={16} />
                </span>
                <div className="ctp-event-popup__detail-info">
                  <span> {event.taken} </span>
                </div>
              </div>
              <ReactTooltip className="tooltip" id="registered-tip" place="top" effect="solid">
                <div>{t('calendar:eventPopup.registeredTooltip')}</div>
              </ReactTooltip>
            </React.Fragment>
          )}
          {event.description && (
            <div className="ctp-event-popup__detail">
              <span className="ctp-event-popup__detail-title">
                {t('calendar:eventPopup.description')}{' '}
              </span>
              <div className="ctp-event-popup__detail-info">
                <span> {event.description} </span>
              </div>
            </div>
          )}
          {event.file && event.file.length > 4 && openAttendingPopup && (
            <button
              className="ctp-event-popup__learn"
              onClick={(e) => openAttendingPopup(e, 'file', event)}
            >
              <span> {t('calendar:eventPopup.learnMore')} </span>
            </button>
          )}
        </div>
        <div className="ctp-popup-footer">
          {this.canEditEvent(userRole, event, dateValid) && (
            <EditButton pathname={eventFormType} event={event} />
          )}
          {(ALLOWED_USER_ROLES.includes(userRole) ||
            (getTrainingType(event) === 'appointment' && dateValid) ||
            userRole === 'Administrator') && (
            <button
              className="button button-red inverted-colors"
              onClick={() => this.handleShowPopup('delete')}
            >
              <span> {t('common:actions.delete')} </span>
            </button>
          )}
          {!event.canceled &&
            (ALLOWED_USER_ROLES.includes(userRole) ||
              (getTrainingType(event) === 'appointment' && dateValid) ||
              userRole === 'Administrator') && (
              <button
                className="button button-red inverted-colors"
                onClick={() => this.handleShowPopup('cancel')}
              >
                <span>
                  {' '}
                  {t('calendar:eventPopup.cancelTrainingType', {
                    type: t(`calendar:trainingTypes.${getTrainingType(event)}`),
                  })}{' '}
                </span>
              </button>
            )}
        </div>
        <ConfirmPopup
          className="is-caution"
          isOpen={this.state.refundPopupOpen}
          cancelCallback={() => this.handleClosePopup('refundPopupOpen')}
          confirmCallback={() => {
            this.handleClosePopup('refundPopupOpen')
            const { repeatCorrelationId } = this.props.event
            if (repeatCorrelationId) {
              this.handleOpenSelectEventsPopup(this.state.mode)
            } else {
              this.handleOpenCancelDeletePopup(this.state.mode)
            }
          }}
          cancelText={t('common:actions.cancel')}
          confirmText={t('calendar:eventPopup.confirmYesEvent', {
            mode: t(`calendar:actionMode.${this.state.mode}`),
          })}
          title={t('calendar:userPopup.confirmationTitle')}
          body={
            <SelectEventRefundOption
              refund={this.state.refund}
              title={t('calendar:eventPopup.refundConfirmBody', {
                mode: t(`calendar:actionMode.${this.state.mode}`),
                title: event.title,
              })}
              onChange={this.handleSetRefund}
            />
          }
        />
        <ConfirmPopup
          isOpen={this.state.confirmPopupOpen}
          cancelCallback={() => this.handleClosePopup('confirmPopupOpen')}
          confirmCallback={() => {
            onClose()
            this.handleAction()
          }}
          cancelText={t('common:actions.cancel')}
          confirmText={t('calendar:eventPopup.confirmYesEvent', {
            mode: t(`calendar:actionMode.${this.state.mode}`),
          })}
          title={t('calendar:userPopup.confirmationTitle')}
          body={t('calendar:eventPopup.confirmActionBody', {
            mode: t(`calendar:actionMode.${this.state.mode}`),
            title: event.title,
          })}
        />
        <ConfirmPopup
          isOpen={this.state.selectEventsToChangePopupOpen}
          cancelCallback={() => this.handleClosePopup('selectEventsToChangePopupOpen')}
          confirmCallback={() => this.handleOpenCancelDeletePopup()}
          cancelText={t('common:actions.cancel')}
          confirmText={t('common:actions.confirm')}
          title={t('calendar:userPopup.caution')}
          body={
            <EditEventSchedule
              onChange={(e) => this.handleEventsToUpdateChange(e)}
              value={this.state.eventsToUpdate}
              formName="calendarEventPopup"
            />
          }
        />
      </div>
    )
  }
}

CalendarEventPopup.propTypes = {
  event: PropTypes.object.isRequired,
  userRole: PropTypes.string.isRequired,
  onEditEvent: PropTypes.func,
  openAttendingPopup: PropTypes.func,
  onCancelReservationEvent: PropTypes.func,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  target: PropTypes.object,
  refetchEvents: PropTypes.func,
  displaySnackbar: PropTypes.func,
  t: PropTypes.func,
}

export default withHookSnackbar(withTranslation(['calendar'])(CalendarEventPopup))
